import { SupplierCompanyMessage } from '../../../types/SupplierCompanyMessage';
import { Text } from '../../cdl/Text/Text';
import { DataSheet } from '../DataSheet/DataSheet';
import { formatAddress } from '../helpers/formatAddress.helper';
import { translate } from '../helpers/translate.helper';

import { CoreDataPopup } from './CoreDataPopup';

interface SupplierInfoPopupProps {
    supplier: SupplierCompanyMessage;
}

export const SupplierInfoDatasheet = ({ supplier }: SupplierInfoPopupProps) => {
    return (
        <DataSheet>
            <DataSheet.Label>{translate('offer.detail.coreData.supplierPopup.name')}</DataSheet.Label>
            <Text>{supplier.name}</Text>

            {supplier.email ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.supplierPopup.emailAddress')}</DataSheet.Label>
                    <Text>{supplier.email}</Text>
                </>
            ) : null}

            {supplier.phone ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.supplierPopup.phoneNumber')}</DataSheet.Label>
                    <Text>{supplier.phone}</Text>
                </>
            ) : null}

            {supplier.address ? (
                <>
                    <DataSheet.Label>{translate('offer.detail.coreData.supplierPopup.address')}</DataSheet.Label>
                    <Text>{formatAddress({ address: supplier.address })}</Text>
                </>
            ) : null}
        </DataSheet>
    );
};

export const SupplierInfoPopup = ({ supplier }: SupplierInfoPopupProps) => {
    return (
        <CoreDataPopup heading={translate('offer.detail.coreData.supplierPopup.headline')}>
            <SupplierInfoDatasheet supplier={supplier} />
        </CoreDataPopup>
    );
};
